import { Controller } from '@hotwired/stimulus'

/*
  Connects to data-controller="visibility"

  Used to toggle items to/from hidden status based on a toggle event
*/
export default class extends Controller {
  static targets = ['hidden', 'visible']

  toggle (event) {
    this.hiddenTargets.forEach(target => {
      target.classList.remove('hidden')
      target.setAttribute('aria-hidden', 'false')
    })

    this.visibleTargets.forEach(target => {
      target.classList.add('hidden')
      target.setAttribute('aria-hidden', 'true')
    })
  }
}
